import { useEffect, useState } from "react"
import { Box, Button } from "@mui/material"
import "./index.css" // Renamed to a more generic name
import Loader from "../GlobalComponents/Loader"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { useLocation, useNavigate } from "react-router-dom"
import { showToast } from "../GlobalComponents/Toast"
import { changePassword } from "../../services/services"
import { FormField } from "../GlobalComponents/Fields"

const ChangePassword = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")

  const stateDetails = useLocation()?.state
  const navigate = useNavigate()
  const disabled = !password || !confirmPassword || password !== confirmPassword

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    const data = await changePassword({ email: stateDetails?.email, password })
    console.log("data", data)
    if (data?.status !== "Success") {
      let message = data.message
      showToast("error", message)
    } else {
      showToast("info", data.message)
      navigate("/")
    }

    setIsLoading(false)
  }

  return (
    <Box className="login-wrapper">
      <Box className="login-container">
        {/* Left Sidebar with Background */}
        <Box className="sidebar-container" />

        {/* Login Form */}
        <Box className="form-container">
          {isLoading && <Loader />}
          <form onSubmit={handleSubmit} className="login-form">
            <Button
              className="back_button_top"
              onClick={() => navigate("/otpScreen")}
            >
              <ArrowBackIcon className="back_icon" />
              <span className="backBtn">Back</span>
            </Button>
            <h1 className="form-header">Change Password</h1>

            <FormField
              label="Password"
              name="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              style={{ marginBottom: "10px" }}
            />

            <FormField
              label="Confirm Password"
              name="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm Password"
            />

            <Button
              type="submit"
              variant="contained"
              className="submit-button"
              disabled={disabled}
              sx={{ backgroundColor: disabled ? "gray" : "#3083EF", color: "white" }}
            >
              Submit
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  )
}

export default ChangePassword
